import { JC_LOADING, JcLoading } from '../utils/JcLoading';

/** Firebase-free metadata accompanying a real-time snapshot. */
export interface JcSnapshotMetadata {
    /**
     * True when the snapshot was served entirely from the local cache and is not
     * yet confirmed by the server. A later snapshot with `fromCache: false`
     * follows once the server responds. Defer irreversible decisions (e.g.
     * navigation) until then.
     */
    readonly fromCache: boolean;
}

/**
 * Treats a cached miss as still loading: returns `JC_LOADING` when `item` is
 * `null` but the snapshot came only from the local cache, so a `null` result
 * always means server-confirmed absence. Positive data passes through
 * immediately, cached or not. Use in hooks whose `null` drives redirects or
 * gating decisions.
 */
export const confirmedAbsence = <T>(
    item: T | null,
    metadata: JcSnapshotMetadata
): T | null | JcLoading => (item === null && metadata.fromCache ? JC_LOADING : item);
